/* Frete da ON sem app (out/2026). Explicação em snippets/onm-frete.liquid. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('pfCfg');
  var CFG = {}; try { CFG = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) {}
  var UF = { AC: 'Acre', AL: 'Alagoas', AP: 'Amapá', AM: 'Amazonas', BA: 'Bahia', CE: 'Ceará', DF: 'Distrito Federal', ES: 'Espírito Santo', GO: 'Goiás', MA: 'Maranhão', MT: 'Mato Grosso', MS: 'Mato Grosso do Sul', MG: 'Minas Gerais', PA: 'Pará', PB: 'Paraíba', PR: 'Paraná', PE: 'Pernambuco', PI: 'Piauí', RJ: 'Rio de Janeiro', RN: 'Rio Grande do Norte', RS: 'Rio Grande do Sul', RO: 'Rondônia', RR: 'Roraima', SC: 'Santa Catarina', SP: 'São Paulo', SE: 'Sergipe', TO: 'Tocantins' };
  var sem = function (t) { return String(t || '').normalize('NFD').replace(new RegExp('[\\u0300-\\u036f]', 'g'), '').toLowerCase().trim(); };
  var ufDoNome = function (n) { n = sem(n); for (var k in UF) if (sem(UF[k]) === n || sem(k) === n) return k; return ''; };
  var din = function (c) { return (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }); };
  // valor redondo sem centavos (R$ 49, R$ 899); com centavos, mostra os centavos
  var din0 = function (c) { return c % 100 === 0 ? (c / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 0, maximumFractionDigits: 0 }) : din(c); };
  var esc = function (t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; };

  /* v249: teto do frete abaixo do frete grátis (teste de out/2026).
     Os valores vêm do metacampo da loja onm.frete_teto, em centavos, pela
     ordem das regiões de Configurações do tema: {"3": 4900, "min": 30000}
     quer dizer frete de no máximo R$ 49 na região 3 para pedidos a partir
     de R$ 300. Quem cobra é a regra da Intelipost; o tema só avisa. Sem o
     metacampo, nada muda. */
  function idxRegiao(uf) {
    var rs = CFG.r || [], n = rs.length;
    for (var i = 0; i < n - 1; i++) if ((rs[i].uf || '').split(',').map(function (x) { return x.trim(); }).indexOf(uf) > -1) return i + 1;
    return n;
  }
  function tetoDe(uf, valor) {
    var T = CFG.teto; if (!T || !uf) return 0;
    var i = idxRegiao(uf), v = parseInt(T[i], 10) || 0, piso = ((CFG.r || [])[i - 1] || {}).piso || 0;
    if (!v || valor < (parseInt(T.min, 10) || 0) || (piso && valor >= piso)) return 0;
    return v;
  }
  function ufLembrado() {
    try { var l = JSON.parse(localStorage.getItem('onm_cep') || 'null'); if (l && l.cep && l.uf) return l.uf; } catch (e) {}   // igual ao onm.js: só vale o CEP digitado
    try { var g = JSON.parse(localStorage.getItem('onm_geo') || 'null'); if (g && g.uf && g.t > Date.now() - 7 * 864e5) return g.uf; } catch (e) {}
    return '';
  }

  /* ── 1. Carrinho: cotação direto da Shopify, no lugar do Dr Cart ──────
     O onm.js preenche o CEP e o estado no widget, aperta o botão e lê as
     linhas .docapp-shipping-rate. Este bloco monta esse mesmo widget,
     escondido, e responde com as cotações da Shopify (Intelipost). Se o
     app ainda estiver instalado e desenhar o dele, este fica quieto. */
  function pedeTaxas(cep, uf) {
    var q = 'shipping_address%5Bzip%5D=' + encodeURIComponent(cep) + '&shipping_address%5Bcountry%5D=Brazil' +
      '&shipping_address%5Bprovince%5D=' + encodeURIComponent(uf);
    return fetch('/cart/prepare_shipping_rates.json?' + q, { method: 'POST', headers: { Accept: 'application/json' } }).then(function () {
      return new Promise(function (ok, falha) {
        var n = 0;
        (function busca() {
          fetch('/cart/async_shipping_rates.json?' + q, { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) {
            if (r.status === 200) return r.json().then(function (j) { if (j && j.shipping_rates) ok(j.shipping_rates); else if (++n < 24) setTimeout(busca, 500); else ok([]); });
            if (r.status === 202 && ++n < 24) return setTimeout(busca, 500);
            ok([]);
          }).catch(function () { if (++n < 24) setTimeout(busca, 700); else falha(); });
        })();
      });
    });
  }
  function montaWidget() {
    var root = document.querySelector('[data-drcart]');
    if (!root || root.querySelector('.docapp-shipping-calculator--button')) return;
    var ops = Object.keys(UF).map(function (k) { return '<option value="' + k + '">' + k + '</option>'; }).join('');
    root.innerHTML = '<div class="pf-emu"><input name="shipping_address[zip]" type="text"><select name="shipping_address[province]">' + ops +
      '</select><button type="button" class="docapp-shipping-calculator--button">ok</button><div class="pf-emu__r"></div></div>';
    var zip = root.querySelector('input'), sel = root.querySelector('select'), saida = root.querySelector('.pf-emu__r');
    root.querySelector('button').addEventListener('click', function () {
      var cep = (zip.value || '').replace(/\D/g, ''), uf = sel.value;
      saida.innerHTML = '';
      if (cep.length !== 8) return;
      pedeTaxas(cep, uf).then(function (taxas) {
        saida.innerHTML = taxas.map(function (t) {
          var c = Math.round(parseFloat(t.price || '0') * 100) || 0;
          var d = t.delivery_range && t.delivery_range.length ? t.delivery_range : (t.delivery_days || []);
          var dias = d.length ? ' (' + (d[0] === d[d.length - 1] ? d[0] + ' dias úteis' : d[0] + ' a ' + d[d.length - 1] + ' dias úteis') + ')' : '';
          return '<div class="docapp-shipping-rate"><input type="radio" value="' + c + '"><div class="docapp-shipping-rate-name"><label>' + esc((t.presentment_name || t.name) + dias) +
            '</label></div><div class="docapp-shipping-rate-price">' + (c === 0 ? 'Grátis' : esc(din(c))) + '</div></div>';
        }).join('');
      }).catch(function () { saida.innerHTML = ''; });
    });
  }
  // o app, se ainda existir, desenha o dele logo no carregamento; só depois disso o nosso entra
  window.addEventListener('load', function () { setTimeout(montaWidget, 1500); });

  /* v249: na barra do frete grátis da caixa, quando o pedido está na faixa
     do teto, a frase ganha o valor máximo do frete na frente:
     "Frete até R$ 49. Mais R$ 200 e o frete fica grátis para o Sudeste e o Paraná".
     O onm.js reescreve a barra a cada mudança da caixa; aqui só se completa
     o texto dele, sem mexer na conta. */
  function tetoNaBarra(txt) {
    if (!CFG.teto || !txt || txt.dataset.pfTetoLock) return;
    var resumo = txt.closest('[data-frete-cfg]'), bar = txt.closest('[data-fretebar]');
    if (!resumo || !bar || bar.hidden) return;
    var atual = txt.textContent || '';
    if (/^Frete até /.test(atual) || /^Frete grátis/.test(atual)) return;
    var uf = ufLembrado(), total = parseInt(resumo.dataset.total, 10) || 0, tt = tetoDe(uf, total);
    if (!tt) return;
    txt.dataset.pfTetoLock = '1';
    txt.textContent = 'Frete até ' + din0(tt) + '. ' + atual;
    setTimeout(function () { delete txt.dataset.pfTetoLock; }, 0);
  }
  if (CFG.teto && window.MutationObserver) {
    new MutationObserver(function (ms) {
      ms.forEach(function (m) {
        var alvo = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        var txt = alvo && (alvo.matches && alvo.matches('[data-fretebar-txt]') ? alvo : alvo.closest && alvo.closest('[data-fretebar-txt]'));
        if (!txt && alvo && alvo.querySelectorAll) txt = alvo.querySelector('[data-fretebar-txt]');
        if (txt) tetoNaBarra(txt);
      });
    }).observe(document.documentElement, { childList: true, subtree: true, characterData: true });
    document.addEventListener('DOMContentLoaded', function () { document.querySelectorAll('[data-fretebar-txt]').forEach(tetoNaBarra); });
  }

  /* ── 2. Ficha: a linha de frete por localização ───────────────────── */
  var ship = document.querySelector('.t-product .ship') || document.querySelector('.ship');
  if (!ship || !CFG.precos) return;
  // a linha do frete fica logo abaixo do preço: preço e entrega lidos juntos
  (function () {
    var pr = document.querySelector('.pr__l2');
    var bloco = pr && (pr.closest('.pr') || pr.parentElement);
    if (bloco && bloco.parentNode && bloco.nextElementSibling !== ship) { bloco.parentNode.insertBefore(ship, bloco.nextSibling); ship.classList.add('ship--preco'); }
  })();

  function regiao(uf) {
    // as regiões vêm das configurações do tema, da mais barata para a mais
    // cara; a última não tem lista de estados e vale para o resto do país
    var rs = CFG.r || [], n = rs.length;
    for (var i = 0; i < n - 1; i++) if ((rs[i].uf || '').split(',').map(function (x) { return x.trim(); }).indexOf(uf) > -1) return rs[i];
    return rs[n - 1] || {};
  }
  function precoAtual() {
    var v = document.getElementById('onmVariantId');
    var p = v && CFG.precos[v.value];
    if (p == null) for (var k in CFG.precos) { p = CFG.precos[k]; break; }
    return p || 0;
  }
  function lembrado() { try { var l = JSON.parse(localStorage.getItem('onm_cep') || 'null'); return l && l.uf ? l : null; } catch (e) { return null; } }
  var lugar = lembrado();   // { cep, uf, cidade } do CEP digitado (o mesmo que a caixa usa)

  /* v235: o campo do CEP tem 16px. Com letra menor, o iPhone dá zoom na
     tela ao tocar no campo; com 16px a tela fica parada. */
  var css = document.createElement('style');
  css.textContent = '.pf{display:flex;align-items:center;gap:10px;font-size:13px;line-height:1.35;min-height:24px}' +
    '.pf svg{width:18px;height:18px;flex:none;fill:none;stroke:currentColor;stroke-width:1.6;stroke-linecap:round;stroke-linejoin:round;opacity:.8}' +
    '.pf__t{flex:1;min-width:0;line-height:1.4}.pf__t b{font-weight:600}.pf__t small{display:block;font-size:11.5px;opacity:.65;margin-top:3px}' +
    '.pf__tr{flex:none;font:inherit;font-size:12.5px;background:none;border:0;padding:4px 0;text-decoration:underline;text-underline-offset:3px;cursor:pointer;color:inherit}' +
    '.pf__f{display:flex;gap:8px;align-items:center;width:100%}' +
    '.pf__f input{flex:1;min-width:0;height:38px;border-radius:999px;border:1px solid rgba(28,28,28,.25);padding:0 14px;font:inherit;font-size:16px!important;background:transparent;color:inherit}' +
    '.pf__f button{flex:none;height:38px;padding:0 16px;border-radius:999px;border:0;background:#1C1C1C;color:#EFEFEF;font:inherit;font-weight:600;font-size:13px;cursor:pointer}' +
    '.pf__erro{font-size:12px;color:#9a3b2a;margin-top:6px}' +
    '.pf__pv{margin:0 0 10px;padding:9px 12px;border-radius:12px;background:linear-gradient(160deg,#F1EBE2,#E4DACB);font-size:12.5px;line-height:1.45}.pf__pv b{font-weight:600}' +
    '.ship--preco{margin:14px 0 0!important;padding:0!important;border:0!important;text-align:left!important}.ship--preco .pf{justify-content:flex-start}.ship--preco .pf__t{text-align:left}';
  document.head.appendChild(css);
  var CAM = '';   // sem ícone: a linha é texto puro, alinhada ao preço

  /* Valor exato do frete deste produto para o CEP digitado: um carrinho à
     parte na Storefront API (canal Headless), com a variante escolhida e o
     endereço, devolve as mesmas opções da Intelipost que o checkout mostra.
     Não toca na caixa do cliente. */
  var cotas = {};
  function cotaProduto(cep, uf, cidade, variante) {
    var chaveC = cep + '|' + variante;
    if (cotas[chaveC]) return cotas[chaveC];
    var gql = function (query, variables) {
      return fetch('/api/2025-01/graphql.json', { method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': CFG.sf },
        body: JSON.stringify({ query: query, variables: variables }) }).then(function (r) { return r.json(); });
    };
    var OPCOES = 'deliveryGroups(first:1){nodes{deliveryOptions{title estimatedCost{amount}}}}';
    var ler = function (cart) { var g = cart && cart.deliveryGroups && cart.deliveryGroups.nodes[0]; return g ? g.deliveryOptions : []; };
    cotas[chaveC] = gql('mutation($i:CartInput!){cartCreate(input:$i){cart{id ' + OPCOES + '} userErrors{message}}}', { i: {
      lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variante, quantity: 1 }],
      buyerIdentity: { countryCode: 'BR', deliveryAddressPreferences: [{ deliveryAddress: { address1: 'Endereço', city: cidade || UF[uf] || uf, province: uf, country: 'BR', zip: cep } }] } } })
      .then(function (j) {
        var cart = j && j.data && j.data.cartCreate && j.data.cartCreate.cart;
        if (!cart) return null;
        var ops = ler(cart), n = 0;
        // as transportadoras respondem em seguida: lê de novo algumas vezes
        return new Promise(function (ok) {
          (function de() {
            if (ops.length || n++ > 5) return ok(ops);
            setTimeout(function () {
              gql('query($id:ID!){cart(id:$id){' + OPCOES + '}}', { id: cart.id }).then(function (k) { ops = ler(k && k.data && k.data.cart); de(); }).catch(function () { ok(ops); });
            }, 900);
          })();
        });
      }).then(function (ops) {
        if (!ops || !ops.length) return null;
        var v = ops.map(function (o) { return Math.round(parseFloat(o.estimatedCost.amount) * 100); }).sort(function (a, b) { return a - b; });
        return v[0];
      }).catch(function () { delete cotas[chaveC]; return null; });
    return cotas[chaveC];
  }
  function variante() { var v = document.getElementById('onmVariantId'); return v && v.value; }

  var PV = CFG.pv ? '<p class="pf__pv"><b>Pré-venda de lançamento.</b> Preço especial nas primeiras unidades, que saem da produção em até ' + CFG.pv + ' dias úteis.</p>' : '';
  function desenha(msgErro) {
    if (!lugar) { ship.innerHTML = PV + '<div class="pf">' + CAM + '<span class="pf__t">Frete e prazo para o seu CEP</span><button type="button" class="pf__tr" data-pf-troca>Calcular</button></div>'; return; }
    var r = regiao(lugar.uf), preco = precoAtual();
    // pré-venda: o prazo da região ganha os dias da produção
    if (CFG.pv) r = { piso: r.piso, prazo: (r.prazo || '').replace(/\d+/g, function (n) { return +n + CFG.pv; }) };
    var onde = lugar.cidade ? lugar.cidade + ', ' + lugar.uf : (UF[lugar.uf] || lugar.uf);
    var tt = tetoDe(lugar.uf, preco);
    // v249: abaixo do frete grátis, quem cobre o teto vê o valor máximo e o piso do grátis
    var gratisAcima = r.piso ? '<small>Grátis acima de ' + din0(r.piso) + '</small>' : '';
    var linha;
    if (r.piso && preco >= r.piso) linha = '<b>Frete grátis</b> para ' + esc(onde);
    else if (tt) linha = 'Frete até <b>' + din0(tt) + '</b> para ' + esc(onde) + gratisAcima;
    else linha = 'Frete para ' + esc(onde) + (r.piso ? '<small>Grátis em compras acima de ' + din(r.piso) + '</small>' : '');
    ship.innerHTML = PV + '<div class="pf">' + CAM + '<span class="pf__t">' + linha + (r.prazo ? '<small>Entrega em ' + esc(r.prazo) + '</small>' : '') + '</span>' +
      '<button type="button" class="pf__tr" data-pf-troca>Trocar</button></div>' + (msgErro ? '<p class="pf__erro">' + esc(msgErro) + '</p>' : '');
    // com CEP e chave, troca a regra pelo valor exato do frete deste produto
    var vid = variante();
    if (CFG.sf && lugar.cep && vid && !msgErro) {
      var meu = lugar.cep + '|' + vid;
      ship.dataset.pfCota = meu;
      cotaProduto(lugar.cep, lugar.uf, lugar.cidade, vid).then(function (c) {
        if (c == null || ship.dataset.pfCota !== meu || ship.querySelector('.pf__f')) return;
        var t = ship.querySelector('.pf__t'); if (!t) return;
        t.innerHTML = (c === 0 ? '<b>Frete grátis</b> para ' + esc(onde) : 'Frete para ' + esc(onde) + ': <b>' + din(c) + '</b>' + (tt ? gratisAcima : '')) +
          (r.prazo ? '<small>Entrega em ' + esc(r.prazo) + '</small>' : '');
      });
    }
  }
  function abreCep() {
    ship.innerHTML = '<div class="pf__f"><input type="text" inputmode="numeric" autocomplete="postal-code" maxlength="9" placeholder="Seu CEP" aria-label="CEP"><button type="button">Calcular</button></div>';
    var inp = ship.querySelector('input'), bt = ship.querySelector('button');
    inp.addEventListener('input', function () { var v = inp.value.replace(/\D/g, '').slice(0, 8); inp.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v; });
    var vai = function () {
      var c = inp.value.replace(/\D/g, '');
      if (c.length !== 8) { inp.focus(); return; }
      bt.disabled = true; bt.textContent = '…';
      fetch('https://viacep.com.br/ws/' + c + '/json/').then(function (r) { return r.json(); }).then(function (d) {
        if (!d || d.erro) { desenha('CEP não encontrado.'); return; }
        lugar = { cep: c, uf: d.uf, cidade: d.localidade };
        try { localStorage.setItem('onm_cep', JSON.stringify(lugar)); } catch (e) {}   // a caixa usa o mesmo CEP
        desenha();
      }).catch(function () { desenha('Não deu para consultar agora. Tente de novo.'); });
    };
    bt.addEventListener('click', vai);
    inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); vai(); } });
    setTimeout(function () { inp.focus(); }, 30);
  }
  ship.addEventListener('click', function (e) { if (e.target.closest('[data-pf-troca]')) { e.preventDefault(); abreCep(); } });
  // trocou medida ou cor: o preço muda e o frete grátis pode mudar
  document.addEventListener('click', function (e) { if (e.target.closest('.size,[data-v]') && !ship.querySelector('.pf__f')) setTimeout(function () { desenha(); }, 150); });

  desenha();
  if (!lugar) {
    // sem CEP digitado: o estado pela internet do visitante, guardado por 7 dias
    var geo = null; try { geo = JSON.parse(localStorage.getItem('onm_geo') || 'null'); } catch (e) {}
    var usa = function (g) { if (!lembrado() && g && g.uf) { lugar = { cep: '', uf: g.uf, cidade: '' }; desenha(); } };
    if (geo && geo.t > Date.now() - 7 * 864e5) usa(geo);
    else fetch('https://get.geojs.io/v1/ip/geo.json').then(function (r) { return r.json(); }).then(function (d) {
      if (!d || d.country_code !== 'BR') return;
      var g = { uf: ufDoNome(d.region), t: Date.now() };
      if (!g.uf) return;
      try { localStorage.setItem('onm_geo', JSON.stringify(g)); } catch (e) {}
      usa(g);
    }).catch(function () {});
  }
})();
